import React, { useRef, useEffect } from 'react';

const SummaryModal = ({ show, summaryId, modalHtml, modalLoading, onClose }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    if (iframeRef.current && modalHtml && !modalLoading) {
      const iframe = iframeRef.current;
      const doc = iframe.contentDocument || iframe.contentWindow.document;
      doc.open();
      doc.write(modalHtml);
      doc.close();
    }
  }, [modalHtml, modalLoading]);

  if (!show) return null;

  return (
    <div className="modal show d-block modal-overlay" tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Summary Email Preview (ID: {summaryId})</h5>
            <button 
              type="button" 
              className="modal-close-button" 
              onClick={onClose}
              aria-label="Close"
            >
              <i className="fas fa-times"></i>
            </button>
          </div>
          <div className="modal-body modal-body-no-padding">
            {modalLoading ? (
              <div className="modal-loading">Loading...</div>
            ) : (
              <iframe
                ref={iframeRef}
className="iframe-email-preview"
                title={`Email Preview - Summary ${summaryId}`}
              />
            )}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>Close</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummaryModal;